
import { Vue } from "vue-class-component";

export default class BookingRetailV2 extends Vue {}
